<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Associar Requisição a Ordem de Serviço
      </p>
    </div>

    <div class="row">
      <div class="col-md-2 q-ml-sm">
        <q-input dense outlined label="Nome da Posição" v-model="numeroReq" />
      </div>
      <div class="col-md-3 q-ml-sm">
        <q-btn
          color="positive"
          icon="check_circle_outline"
          no-caps
          label="Associar"
          @click="vincular"
        />
      </div>
    </div>

    <div class="q-mt-lg">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        title="Requisições já associadas a Ordem de Serviço"
        :filter="filter"
        :rows="rows"
        class="tabela-tamanho-fixo"
        :columns="columns"
        :loading="disable"
        dense
        v-model:pagination="pagination"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-input
            outlined
            rounded
            dense
            debounce="300"
            v-model="filter"
            placeholder="Buscar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>

        <template #body-cell-deletar="props">
          <q-td>
            <q-btn
              color="negative"
              round
              class="q-ml-sm"
              icon="delete"
              @click="apagarRow(props.row.id)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "voucherId",
    label: "Riq. ID",
    field: "voucherId",
    align: "left",
  },
  {
    name: "descricao",
    label: "Vinculado Em",
    field: (row) =>
      row.marcoTemporal.createdAt.split(" ")[0].split("-").reverse().join("/"),
    align: "left",
  },

  {
    name: "acumulado",
    label: "Vinculado Por",
    field: (row) => row.vinculadoPor.usuario.nome,
    align: "left",
  },
];

import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
export default {
  setup() {
    const numeroReq = ref("");
    const store = useStore();
    const quasar = useQuasar();
    const route = useRoute();
    const rows = ref([]);
    const disable = ref(true);
    let filter = ref("");
    const id = route.params.id;

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const vincular = async () => {
      try {
        await store.dispatch("ordem/associarOrdem", {
          osid: id,
          voucher_id: numeroReq.value,
        });

        quasar.notify({
          message: "Associado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getVinculados();
      } catch (error) {
        quasar.notify({
          message: "Erro a o associar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getVinculados = async (page = 1, rowsPerPage = 15) => {
      let response = await store.dispatch("ordem/listarAssociados", {
        osid: id,
        per_page: rowsPerPage,
        page: page,
      });

      rows.value = response.data.result.operacoes;

      disable.value = false;
    };

    onMounted(getVinculados);

    const handleRequest = async () => {
      getVinculados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getVinculados();
      }
    );

    return {
      numeroReq,
      vincular,
      columns,
      rows,
      disable,
      filter,
      getVinculados,
      pagination,
      handleRequest,
    };
  },
};
</script>

<style></style>
